/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComponentSchema } from './ComponentSchema';
import {
    ComponentSchemaFromJSON,
    ComponentSchemaFromJSONTyped,
    ComponentSchemaToJSON,
} from './ComponentSchema';

/**
 * 
 * @export
 * @interface Network
 */
export interface Network {
    /**
     * 
     * @type {number}
     * @memberof Network
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof Network
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof Network
     */
    updated: Date;
    /**
     * 
     * @type {ComponentSchema}
     * @memberof Network
     */
    component: ComponentSchema;
    /**
     * 
     * @type {string}
     * @memberof Network
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof Network
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Network
     */
    autoCreateSubnetworks: boolean;
}

/**
 * Check if a given object implements the Network interface.
 */
export function instanceOfNetwork(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "component" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "autoCreateSubnetworks" in value;

    return isInstance;
}

export function NetworkFromJSON(json: any): Network {
    return NetworkFromJSONTyped(json, false);
}

export function NetworkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Network {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'component': ComponentSchemaFromJSON(json['component']),
        'link': !exists(json, 'link') ? undefined : json['link'],
        'name': json['name'],
        'autoCreateSubnetworks': json['auto_create_subnetworks'],
    };
}

export function NetworkToJSON(value?: Network | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'component': ComponentSchemaToJSON(value.component),
        'link': value.link,
        'name': value.name,
        'auto_create_subnetworks': value.autoCreateSubnetworks,
    };
}

